import React from 'react'
import {Controller} from 'react-hook-form'
import {Autocomplete, Paper} from '@mui/material'
import TextField from '@mui/material/TextField'
import {FormErrorText} from './index.js'
import {useI18n, useIsRtl} from 'store/Store.js'
import styled from 'styled-components'

const FormAutoComplete = ({
    name,
    control,
    rules,
    required,
    disabled,
    options,
    label,
    errors,
}) => {
    const {i18n} = useI18n()
    const isRtl = useIsRtl()

    return (
        <Container>
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) => (
                    <Autocomplete
                        PaperComponent={(props) => (
                            <Paper
                                {...props}
                                style={{direction: isRtl ? 'rtl' : 'ltr'}}
                            />
                        )}
                        options={options}
                        value={value ?? null}
                        onChange={(event, newValue) => {
                            onChange(newValue)
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                fullWidth
                                label={label ?? name}
                                required={required}
                                disabled={disabled}
                            />
                        )}
                    />
                )}
            />
            {errors?.[name] && (
                <FormErrorText>
                    {i18n.t('welcome.invalidInput', {input: label})}
                </FormErrorText>
            )}
        </Container>
    )
}

export default FormAutoComplete

const Container = styled.div`
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
`
